import React from 'react';
import './TitleChart.scss'

const TitleChart = ({title, isShow}) => {
  return (
    <div className='title__chart'>
      <h5 className='iransans-b'>{title}</h5>
      {/*{isShow && (*/}

      {/*  <div className='title__month'>*/}
      {/*    <button>*/}
      {/*      /!*<img src={arrowRight} alt="" />*!/*/}
      {/*    </button>*/}
      {/*    <span className='iransans-m'>1403</span>*/}
      {/*    <button>*/}
      {/*      /!*<img src={arrowLeft} alt="" />*!/*/}
      {/*    </button>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
};

export default TitleChart;